import {
  LOAD_PREVIEW_PDF,
  CLOSE_LOAD_PREVIEW_PDF,
  LOAD_SIGN_AND_SEND,
  CLOSE_LOAD_SIGN_AND_SEND
} from '../../constants/employer'

const loaderReducer = (
  state = {
    showLeItemLoader: false,
    loadSignAndSend: false
  },
  action
) => {
  switch (action.type) {
    case LOAD_PREVIEW_PDF:
      return Object.assign(
        {},
        { ...state },
        {
          showLeItemLoader: true
        }
      )

    case CLOSE_LOAD_PREVIEW_PDF:
      return Object.assign(
        {},
        { ...state },
        {
          showLeItemLoader: false
        }
      )

    case LOAD_SIGN_AND_SEND:
      return Object.assign(
        {},
        { ...state },
        {
          loadSignAndSend: true
        }
      )

    case CLOSE_LOAD_SIGN_AND_SEND:
      return Object.assign(
        {},
        { ...state },
        {
          loadSignAndSend: false
        }
      )

    default:
      return state
  }
}

export default loaderReducer
